
import React from "react";


const LoggetUt = () => {

    return (
        <div>
            Du er nu logget ud af hundedatabasen
        </div>
    );
};

export default LoggetUt;
